import { Component, HostBinding, HostListener, ViewChild, input, output } from '@angular/core';
import { Observable } from 'rxjs';
import { ZiroIcons } from '../../../../shared/models/ziro-icons.enum';
import DragOverEvent = JQuery.DragOverEvent;
import DragLeaveEvent = JQuery.DragLeaveEvent;

@Component({
  selector: 'ziro-saml-import-btn',
  templateUrl: './saml-import-button.component.html',
  styleUrls: ['./saml-import-button.component.scss'],
  standalone: false,
})
export class SamlImportButtonComponent {
  ziroIcons = ZiroIcons;
  @ViewChild('hiddenInput') fileInput: HTMLElement;
  @HostBinding('style.opacity') private opacity = '1';
  readonly uploadEvent = input<(formData: FormData) => Observable<any>>();
  readonly fileExtension = input('');
  readonly buttonStyle = input('btn-primary');
  readonly dataAutomation = input('');
  readonly iconPending = input(this.ziroIcons.SAVING);
  readonly icon = input(this.ziroIcons.DOWNLOAD);
  readonly label = input('');
  readonly isDisabled = input(false);
  readonly invalidTypeError = output<boolean>();
  readonly successfulImport = output<boolean>();
  uploadedFile: File = null;
  isPending = false;

  @HostListener('dragover', ['$event']) onDragOver(event: DragOverEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.opacity = '0.8';
  }

  @HostListener('dragleave', ['$event']) onDragLeave(event: DragLeaveEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.opacity = '1';
  }

  @HostListener('drop', ['$event']) onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.opacity = '1';
    this.uploadFile(event.dataTransfer.files);
  }

  uploadFile(files: FileList): void {
    const file = files[0] as File;
    if (file) {
      if (!this._verifyFileExtension(file)) {
        this.invalidTypeError.emit(true);
        this.uploadedFile = null;
        return;
      }
      this.isPending = true;
      const formData = new FormData();
      formData.append('upload', file, file.name);
      this.uploadEvent()(formData).subscribe(() => {
        this.isPending = false;
        this.successfulImport.emit(true);
      });
    }
    this.uploadedFile = null;
  }

  private _verifyFileExtension(file: File): boolean {
    const fileExtension = file.name.slice(file.name.length - this.fileExtension().length);
    return fileExtension === this.fileExtension();
  }
}
